// Libs
import React, { PureComponent } from 'react'

import {lightFEBlue, hoverFEBlue} from 'hfty-styles/src/colors'

// Styles
const styles = {
  td: {
    padding: '10px 9px',
    cursor: 'pointer',
  },
  oddColor: {
    backgroundColor: lightFEBlue,
  },
  selectedColor: {
    backgroundColor: hoverFEBlue,
  },
  gridId: {
    overflowWrap: 'break-word',
    width: '70%',
  },
}

type Props = {
  point: Object,
  pointNumber: ?number,
  onHover: Function,
  jobStatus: string,
  filter: ?string,
  selectedPoint: ?number,
}

class SamplingPointDetail extends PureComponent {
  props: Props

  constructor (props: Props) {
    super(props)
    this.onHover = this.onHover.bind(this)
  }

  onHover (id) {
    return () => this.props.onHover(id)
  }

  displayPercentSign (filter, value) {
    if (value && filter.includes('cation_sat')) {
      return value + '%'
    }
    return value
  }

  render () {
    const { point, point: { soilTestResults: soilTests }, pointNumber, filter, selectedPoint, jobStatus } = this.props
    const soilTest = soilTests[0] ? soilTests[0] : {}

    return (
      <tr
        onMouseEnter={this.onHover(point.id)}
        onMouseLeave={this.onHover(null)}
        style={
          selectedPoint === point.id ? styles.selectedColor : pointNumber % 2 ? styles.oddColor : { flex: '1 1 auto' }
        }>
        <td style={styles.td}>{pointNumber + 1}</td>
        <td style={styles.td}>{point.gridId}</td>
        <td style={styles.td}>
          {filter ? (
            this.displayPercentSign(filter, soilTest[filter])
          ) : (
            `${point.latitude.toFixed(4)}, ${point.longitude.toFixed(4)}`
          )}
        </td>
      </tr>
    )
  }
}

export default SamplingPointDetail
